import { ReactNode } from 'react'
import { GuideVariantName, guidePath } from '../../constants/guidePaths'
import { GuideVariant } from './core'
import { GuidePage } from './index'
import { defaultVariant } from './variants/default'
import { welciaVariant } from './variants/welcia'
import { aiseiVariant } from './variants/aisei'

type GuideRoute = {
  path: string
  element: ReactNode
}

/**
 * /guide とその系統別variant。いずれも未認証で開ける（constants/publicPaths.ts が
 * /guide 以下をまとめて通すので、版を足してもあちらは触らない）。
 * 紙のA4シート裏面に印字するURLなので、パスは変えないこと。
 *
 * コンテンツは系統別に静的に持ち、入口で振り分ける。ページ自体は未認証で開くため
 * 動的分岐はしない（閲覧者を判定する手段が無い）。
 * 入口は2つ: 紙のQRは版のURLを直接指す。アプリ内導線（portal・ヘルプモーダル）は
 * back が解決した版名で行き先を決める（constants/guidePaths.ts）。
 *
 * Record なので、版を足してページを足し忘れると型検査で落ちる。
 */
const GUIDE_PAGES: Record<GuideVariantName, GuideVariant> = {
  default: defaultVariant,
  welcia: welciaVariant,
  aisei: aiseiVariant,
}

export const guideRoutes: GuideRoute[] = (
  Object.keys(GUIDE_PAGES) as GuideVariantName[]
).map((variant) => ({
  path: guidePath(variant),
  element: <GuidePage {...GUIDE_PAGES[variant]} />,
}))
